<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="project" :key="project.nom" class="project-details">
        <RouterLink class="backward-link" :to="`/portfolio/${category}`">
          <div>
            <div id="link-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
              <span>Retour aux projets</span>
            </div>
          </div>
        </RouterLink>

        <div class="name-description">
          <h1>
            {{ project.nom }}
          </h1>
          <p class="gray-bck project-description">{{ project.description }}</p>
        </div>

        <div class="grid-section">
          <video v-if="project.video" class="visual" controls width="100%" height="250">
            <source :src="project.video" type="video/mp4" />
          </video>
          <img
            v-else
            class="visual"
            :src="project.background"
            :alt="project.nom"
            @click="openLightbox(project.background)"
            style="cursor: zoom-in;"
          />

          <SubSection
            v-if="project.brief"
            id="brief"
            icon="/img/pictogramme/brief.png"
            alt="brief"
            title="BRIEF"
            :content="project.brief"
          />

          <SubSection
            v-if="project.date"
            id="date"
            icon="/img/pictogramme/date.svg"
            alt="date"
            title="DATE"
            :content="project.date"
          />

          <SubSection
            v-if="project.livrable"
            id="livrable"
            icon="/img/pictogramme/livrable.png"
            alt="livrable"
            title="LIVRABLE"
            :content="project.livrable"
          />

          <SubSection
            v-if="project.skills"
            id="skills"
            icon="/img/pictogramme/header/stars.svg"
            alt="compétences"
            title="COMPÉTENCES ASSOCIÉES"
            :content="project.skills"
            :isSkills="true"
          />

          <SubSection
            v-if="project.contexte"
            id="contexte"
            icon="/img/pictogramme/contexte.svg"
            alt="contexte"
            title="CONTEXTE"
            :content="project.contexte"
          />

           <SubSection
            v-if="project.synopsis"
            id="synopsis"
            icon="/img/pictogramme/resume.png"
            alt="synopsis"
            title="SYNOPSIS"
            :content="project.synopsis"
          />
 
        </div>

        
        <template v-for="(link, index) in projectLinks" :key="index">
          <a v-if="project[link.key]" class="web-link" target="_blank" :href="project[link.key]">
            <button>
              <svg style="margin-right:1rem" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
                <path d="M5.25 5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V14a.75.75 0 0 1 1.5 0v3.75A2.25 2.25 0 0 1 16.75 20H5.25A2.25 2.25 0 0 1 3 17.75V6.25A2.25 2.25 0 0 1 5.25 4H9a.75.75 0 0 1 0 1.5H5.25z"/>
                <path d="M20.78 2.22a.75.75 0 0 1 0 1.06l-10 10a.75.75 0 1 1-1.06-1.06l10-10a.75.75 0 0 1 1.06 0z"/>
                <path d="M13 2.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0V3.5h-5.75a.75.75 0 0 1-.75-.75z"/>
              </svg>
              {{ link.label }}
            </button>
          </a>
        </template>
       

        <div v-if="showProjectsList" class="projects-modal">
          <div class="modal-content">
            <div style="margin:1rem;display:flex; justify-content: space-between;align-items: center; flex-direction: row-reverse;">
              <button class="close-modal" @click="showProjectsList = false">×</button>
              <h4 id="modal-title">Sélectionner un projet</h4>
            </div>
            <ul class="projects-list">
              <li v-for="(proj, index) in getAllProjects()" :key="index">
                <RouterLink :to="`/portfolio/tous/${normalizeName(proj.nom)}`">
                  <div class="project-item">
                    <div class="project-thumbnail-number">{{ index + 1 }}</div>
                    <div>
                      <p class="project-name">{{ proj.nom }}</p>
                      <p class="project-description">{{ proj.description }}</p>
                    </div>
                  </div>
                </RouterLink>
              </li>
            </ul>
          </div>
        </div>

        <hr>

        <div class="project-counter">
          <div style="color:var(--yellow-white)">{{ currentIndex + 1 }}</div> sur <div style="color:var(--yellow-white)">{{ totalProjects }}</div>
        </div>
        <div class="navigation">
          <RouterLink
            v-if="prevProject"
            :to="`/portfolio/tous/${normalizeName(prevProject.nom)}`"
          >
            <button>← Précédent : {{ prevProject.nom }}</button>
          </RouterLink>
          <RouterLink
            v-if="nextProject"
            :to="`/portfolio/tous/${normalizeName(nextProject.nom)}`"
          >
            <button>Suivant : {{ nextProject.nom }} →</button>
          </RouterLink>
        </div>
      </div>

      <div class="not-found" v-else key="notfound">
        <h1 class="unfound">AUCUN PROJET TROUVÉ</h1>
        <RouterLink to="/competences"><button>Revenir en arrière</button></RouterLink>
      </div>
    </transition>

    <VueEasyLightbox
      :visible="showLightbox"
      :imgs="[lightboxImg]"
      @hide="showLightbox = false"
    />
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';
import SubSection from '../components/SubSection.vue';

export default {
  components: {
    SubSection,
    VueEasyLightbox
  },
  data() {
    return {
      project: null,
      prevProject: null,
      nextProject: null,
      category: this.$route.params.category,
      showLightbox: false,
      lightboxImg: '',
      showProjectsList: false,
      projectLinks: [
        { key: 'site', label: 'Voir le site web' },
        { key: 'rapport', label: 'Voir le rapport' },
        { key: 'animation', label: "Voir l'animation" },
        { key: 'instagram', label: 'Voir le compte instagram' },
        { key: 'dossier', label: 'Voir le dossier de production' },
        { key: 'scenario', label: 'Voir le scénario' },
        { key: 'presentation', label: 'Voir la présentation' },
        { key: 'video_site', label: 'Voir la vidéo' }
      ]
    };
  },
  computed: {
    currentIndex() {
      const { name } = this.$route.params;
      const allProjects = this.getAllProjects();
      return allProjects.findIndex(
        (proj) => this.normalizeName(proj.nom) === this.normalizeName(name)
      );
    },
    totalProjects() {
      return this.getAllProjects().length;
    },
  },
  created() {
    this.updateProjectData();
  },
  watch: {
    $route: 'updateProjectData',
  },
  methods: {
    openLightbox(img) {
      this.lightboxImg = img;
      this.showLightbox = true;
    },
    normalizeName(name) {
      return name.toLowerCase().replace(/ /g, '-');
    },
    getAllProjects() {
      return [
        {
          nom: 'Quantum',
          description: "Création d'une marque de bière fictive",
          background: 'https://but1.mmi-iutsf.org/S2/2024/quantum.2024.mmibut1.org/public/assets/logos/LOGOQUANTUMBLANC.png',
          skills: ['photoshop.png', 'illustrator.png', 'canva.png', 'js.svg', 'html.svg', 'css.svg', 'php.png'],
          date: "Juin 2024",
          brief: "Créer de A à Z une marque de bière fictive avec charte graphique, site web, vidéos promotionnelles, posts Instagram, etc.",
          livrable: " De multiple livrables étaient à rendre pour ce projet, comme le site web de vente de bière, l'affiche de promotion de la marque, la charte graphique, le benchmark ainsi que des vidéos publicitaires",
          contexte: "Gros projet de SAE du semestre 1 réalisé par groupe de 6.",
          instagram: "https://www.instagram.com/quantum.off/"
        },
        {
          nom: 'Eh Connard !',
          description: "Création d'une association féministe fictive",
          background: 'https://but1.mmi-iutsf.org/S1/2024_S1/groupe_e/public/images/LOGOOFFPOURDEVRAI.png',
          skills: ['photoshop.png', 'illustrator.png', 'canva.png', 'js.svg', 'html.svg', 'css.svg', 'php.png'],
          date: "Janvier 2024",
          brief: "Créer une association féministe fictive avec un site web, une charte graphique, un logo, un compte Instagram, et autres.",
          livrable: " Rendu du site web, de la charte graphique, du logo",
          contexte: "Projet réalisé pour la grosse SAE du semestre 1 en groupe de 7.",
          site: "https://but1.mmi-iutsf.org/S1/2024_S1/groupe_e/quiz.php"
        },
        // {
        //   nom: 'Mbappé',
        //   description: 'Correction colorimétrique avec une image de Kylian Mbappé',
        //   background: '/img/projet/kylian.jpg',
        //   skills: ['photoshop.png'],
        //   date: "Octobre 2024"
        // },
        {
          nom: 'Bande-Dessinée',
          description: "Bande-dessinée interactive",
          background: '/img/projet/bande-dessinee.jpg',
          skills: ['animate.png', 'illustrator.png', 'photoshop.png'],
          date: "Novembre 2024",
          brief: "Créer une bande-dessinée interactive avec Animate à partir d'un scénario que l'on écrit, en utilisant les outils d'animation d'Animate.",
          livrable: " Rendu du scénario de la bande-dessinée, et du dossier de l'animation",
          contexte: "Projet réalisé en cours de Création et design interactif par groupe de 4",
          animation: "https://alexandre-meux.alwaysdata.net/INTRO_VOUS_ETES_MORT.html",
        },
        {
          nom: 'Gyökeres',
          description: "Affiche sur le footballeur Viktor Gyökeres",
          background: '/img/projet/gyokeres.jpg',
          skills: ['photoshop.png'],
          date: "Novembre 2024"
        },
        {
          nom: 'Site Quantum',
          description: "Site web de vente de bière",
          background: '/img/projet/quantum.jpg',
          date: "Juin 2024",
          site: "https://but1.mmi-iutsf.org/S2/2024/quantum.2024.mmibut1.org",
          skills: ['php.png', 'css.svg', 'js.svg', 'filezilla.png', 'vscode.png'],
          brief: "Créer un site web pour notre marque de bière fictive Quantum,  en PHP, CSS, JS ainsi qu'en utilisant une base de données MySQL",
          livrable: " Rendu du dossier du site web + soutenance pour présenter le site.",
          contexte: "Projet réalisé en lien avec la SAE principale du semestre 2, réalisé en groupe de 6",
        },
        {
          nom: 'Vitinha',
          description: 'Affiche sur le footballeur Vitinha',
          background: '/img/projet/vitinha.jpg',
          skills: ['photoshop.png'],
          date: "Novembre 2024"
        },
        {
          nom: 'Marseille.fr',
          description: 'Maquette du site web de Marseille sur axure',
          background: '/img/projet/marseille.jpg',
          date: "Mars 2024",
          skills: ['axure.png'],
          brief: "Reproduire dans une maquette le site de la ville de Marseille sur Axure.",
          livrable: "Rednu du fichier axure au format .rp",
          contexte: "Projet réalisé en cours d'ergonomie et accessibilité en individuel.",
        },
        {
          nom: 'Shanks',
          description: 'Affiche sur Shanks de One Piece',
          background: '/img/projet/shanks.jpg',
          skills: ['photoshop.png'],
          date: "Mars 2024",
        },
        {
          nom: 'New World Symphony',
          description: 'Clip audiovisuel',
          background: '/img/projet/clip.jpg',
          date: 'Juin 2024',
          skills: ["premierepro.png", "canva.png"],
          brief: "Créer de toute pièce un clip audiovisuel filmé avec le téléphone.",
          livrable: " Rendu d'un dossier de production et du clip audiovisuel.",
          contexte: "Projet de fin de semestre réalisé de manière individuelle pour les cours d'audiovisuels.",
          video: '/video/clip.mp4',
          dossier: "/files/dossier_de_production.pdf"
        },
        {
          nom: 'Vitinha 2.0',
          description: 'Double éclairage sur Vitinha',
          background: '/img/projet/vitinha2.jpg',
          skills: ['photoshop.png'],
          date: "Novembre 2024"
        },
        {
          nom: 'João Neves',
          description: 'Affiche sur João Neves',
          background: '/img/projet/joaoNeves.jpg',
          skills: ['photoshop.png'],
          date: "Août 2024"
        },
        {
          nom: "Scène d'épouvante",
          description: 'Vidéo épouvante réalisée avec la caméra 3D sur After Effects',
          background: '/img/projet/epouvante.jpg',
          date: 'Novembre 2024',
          skills: ["aftereffects.png", "photoshop.png"],
          brief: "Créer une scène d'épouvante en utilisant la caméra 3D sur After Effects.",
          livrable: " La vidéo d'épouvante",
          contexte: "Projet réalisé en cours d'audiovisuel de manière individuelle.",
          video: '/video/epouvante.mp4'
        },
        {
          nom: 'Limites planétaires',
          description: 'Affiche sur les limites planétaires',
          background: '/img/projet/limitesPlanetaires.jpg',
          skills: ['illustrator.png', "photoshop.png"],
          date: "Avril 2024",
          brief: "Créer une affiche traitant d'une des limites planétaires,celle que j'ai choisi était l'introduction d’entités nouvelles dans la biosphère",
          livrable: " Rendu de l'affiche ainsi que d'un dossier de production",
          contexte: "Projet réalisé en cours de graphisme en individuel.",
          dossier: "/files/limites_planetaires.pdf"
        },
        {
          nom: 'Shanks Website',
          description: 'Site web consacré au personnage de Shanks dans One Piece',
          background: '/img/projet/shanksSite.jpg',
          date: "Avril 2024",
          skills: ['html.svg', 'css.svg', 'js.svg', 'vscode.png'],
          livrable: " Rendu du lien web vers le site hébergé sur alwaysdata",
          contexte: 'Projet réalisé pour la SAE "produire du contenu multimédia" du semestre 4 en groupe 5.',
          brief: "Créer un site utilisant les différents mode de display en CSS comme le flexbox et le grid puis l'héberger sur alwaysdata.",
          site: "https://alexandre-meux.alwaysdata.net/shanks_website/"
        },
        {
          nom: 'JME',
          description: 'Affiche pour promouvoir la journée mondiale de l\'eau',
          background: '/img/projet/JME.jpg',
          skills: ['photoshop.png'],
          date: "Novembre 2023",
          brief: "Créer une affiche faisant la promotion de la journée mondiale de l'eau du 22 mars 2024",
          livrable: " Rendu de l'affiche au format .psd",
          contexte: "Projet réalisé en cours de graphisme en individuel.",
        },
        {
          nom: 'AccessiWeb',
          description: "Maquette axure visant à expliquer tous les rouages de l'accessibilité sur le web",
          background: '/img/projet/accessiWeb.jpg',
          date: "Avril 2024",
          skills: ['axure.png'],
          brief: "Créer une maquette d'application mobile axure pour expliquer les rouages de l'accessibilité sur le web",
          livrable: " Rendu de la maquette au format .rp",
          contexte: "Projet réalisé en cours d'ergonomie et accessibilité en individuel.",
        },
        {
          nom: 'Auto-Portrait',
          description: 'Auto-Portrait',
          background: '/img/projet/autoPortrait.jpg',
          skills: ['illustrator.png'],
          date: "Novembre 2023",
          brief: "Concevoir son auto-portrait sur Illustrator.",
          livrable: " Rendu du portrait au format .psd",
          contexte: "Projet réalisé en cours de graphisme en individuel.",
        },
        {
          nom: 'ErgoWeb',
          description: "Maquette axure traitant de l'ergonomie web",
          background: '/img/projet/ergoWeb.jpg',
          date: "Décembre 2023",
          skills: ['axure.png'],
          brief: "Créer une maquette d'application mobile axure pour expliquer les rouages de l'accessibilité sur le web",
          livrable: " Rendu de la maquette au format .rp",
          contexte: "Projet réalisé en cours d'ergonomie et accessibilité en individuel.",
        },
        {
          nom: 'Cartel',
          description: 'Affiche inspirée des cartels de la drogue sud-américains',
          background: '/img/projet/cartel.jpg',
          skills: ['photoshop.png'],
          date: "Octobre 2024"
        },
        {
          nom: 'Films du moment',
          description: 'Page web présentant les films du moment',
          background: '/img/projet/filmDuMoment.jpg',
          date: "Mars 2024",
          skills: ['html.svg', 'css.svg', 'vscode.png'],
          brief: "Reproduire unne page web en utilisant des outils css tels que la flexbox ou le grid.",
          livrable: "Rendu du lien vers le site suite à l'hébergement de  sur alwaysdata",
          contexte: "Projet réalisé en cours d'intégration web en individuel.",
          site: "https://alexandre-meux.alwaysdata.net/filmsDuMoment/"
        },
        {
          nom: 'Digital Detox',
          description: "Vidéo sur la detox digital.",
          background: '/img/projet/digitaldetox.jpg',
          date: "Avril 2024 ",
          skills: ["premierepro.png"],
          brief: "Créer une vidéo pour une campagne de sensibilisation face au danger des écrans et des réseaux sociaux",
          livrable: " Rendu de la vidéo au monté au format mp4.",
          contexte: "Projet réalisé en cours d'Anglais par groupe de 2",
          video: '/video/digital-detox.mp4'
        },
        {
          nom: 'Les Arènes',
          description: "Vidéo sur les Arènes d'Évry-Courcouronnes",
          background: '/img/projet/lesArenes.jpg',
          date: 'Novembre 2024',
          skills: ["premierepro.png"],
          brief: "Monter une vidéo faisant la promotion des Arènes d'Évry-Courcouronnes à partir des rushs fournis par l'enseignant, la vidéo doit durer 45 secondes à 1 minute.",
          livrable: " Rendu de la vidéo au format .mp4",
          contexte: "Projet réalisé en d'écriture et multimédia en individuel.",
          video: "/video/arenes.mp4"
        },
        {
          nom: 'Festival',
          description: 'Campagne pour le festival de la jeunesse européenne',
          background: '/img/projet/festival.jpg',
          skills: ['photoshop.png', 'illustrator.png', 'canva.png'],
          date: "Juin 2024",
          brief: "Créer l'identité graphique d'un festival avec logo, affiche promotionnelle, étiquette, signalétique...",
          livrable: "Rendu d'une présentation des livrables au format .pdf",
          contexte: "Projet réalisé en cours de graphisme en individuel.",
          presentation: "/files/festival.pdf"
        },
        {
          nom: 'Barcola',
          description: 'Affiche sur Bradley Barcola',
          background: '/img/projet/barcola.jpg',
          skills: ['photoshop.png'],
          date: "Août 2024"
        },
        {
          nom: 'Player',
          description: "Reproduction d'un player audio",
          background: '/img/projet/player.jpg',
          date: "Octobre 2024",
          skills: ["/aftereffects.png", "illustrator.png"],
          brief: "Créer une vidéo grâce à After Effects qui doit simuler avec le fond d'un écran de démarrage d'ordinateur un player",
          livrable: " Rendu de la vidéo au format .mp4",
          contexte: "Projet réalisé en cours de motion design en individuel.",
          video: "/video/player.mp4"
        },
        {
          nom: 'Lame secrète',
          description: 'Téléphone lame secrète',
          background: '/img/projet/lameSecrete.jpg',
          skills: ['photoshop.png'],
          date: "Décembre 2023",
          brief: "Créer une affiche pour promouvoir un téléphone fictif qui permettrait d'assassiner ses ennemis grâce à une lame cachée à l'intérieur",
          livrable: " Affiche au format png",
          contexte: "Projet réalisé en cours de graphisme en individuel.",
        },
        {
          nom: 'Site Eh Connard!',
          description: 'Site web féministe',
          background: '/img/projet/ehConnard.jpg',
          date: "Janvier 2024",
          skills: ['php.png', 'css.svg', 'vscode.png'],
          brief: "Nous devions créer un site web féministe en utilisant les langages CSS et PHP, en employant PHP pour générer des templates HTML.",
          livrable: " Le dossier du site web",
          contexte: "Projet réalisé durant la SAE du semestre 1 consacré à la création du site.",
          site: "https://but1.mmi-iutsf.org/S1/2024_S1/groupe_e/quiz.php"
        },
        {
          nom: 'Campagne publicitaire',
          description: "Campagne publicitaire contre l'étalement urbain",
          background: '/img/projet/campagnePublicitaire.jpg',
          skills: ['photoshop.png'],
          date: "Décembre 2024",
          brief: "Créer une campagne publicitaire fictive contre l'étalement urbain.",
          livrable: " Rendu d'une présentation des livrables au format pdf.",
          contexte: "Projet réalisé en cours de graphisme en individuel.",
          presentation: "/files/campagne_publicitaire.pdf"
        },
        {
          nom: 'Générique',
          description: 'Générique de fin de comédie romantique',
          background: '/img/projet/generique.jpg',
          date: "Janvier 2025",
          skills: ["/aftereffects.png"],
          brief: "Créer une vidéo de générique de fin de comédie romantique",
          contexte: "Projet réalisé en cours de motion design en individuel.",
          video: "/video/generique.mp4",
          livrable: " Rendu de la vidéo au format .mp4",
        },
        {
          nom: "Bat'H Game",
          description: "Application interactive d'escape game conçue pour le bâtiment H de notre IUT",
          background: '/img/projet/bath.jpg',
          date: "Mai 2025",
          brief: "Créer une vidéo de générique de fin de comédie romantique",
          contexte: 'Projet réalisé pour la SAE "produire du contenu multimédia" du semestre 4 en groupe 5.',
          skills: ['flutterflow.png', 'gdoc.png'],
          livrable: " Rendu de l'application flutterflow et des wireframes, maquettes"
        },
        {
          nom: 'Sapik',
          description: "Remodernisation d'une marque de  piment fictive",
          background: '/img/projet/sapik.jpg',
          skills: ['photoshop.png', 'illustrator.png', 'canva.png'],
          date: "Mars 2025",
          livrable: " Le logo, l'affiche, le mockup, les posts instagram, les étiquettes, les contenus aditionnels",
          contexte: 'Projet réalisé pour la SAE "produire du contenu multimédia" du semestre 4 en groupe 5.',
          brief: "Remoderniser l'image d'une marque de piment fictive, en créant un logo, une affiche promotionnelle, un mockup, des posts instagram, des étiquettes mettre sur nos bouteilles de piment.",
          presentation: "/files/sapik_presentation.pdf"
        },
        {
          nom: 'Infographie animée',
          description: "Infographie animée sur le thème de la difficulté",
          background: '/img/projet/infographie.jpg',
          skills: ['illustrator.png', 'animate.png'],
          date: "Janvier 2025",
          livrable: "Rendu du fichier animate et du dossier du site web",
          contexte: 'Projet réalisé pour la SAE du semestre 3 en groupe de 3.',
          brief: "Créer une infographie animée grâce à Animate sur un thème d'actualité qui était pour nous le thème de la difficulté, en ce sens les émotions humaines comme le stress, la peur.",
          animation: "https://alexandre-meux.alwaysdata.net/menu_difficulte.html",
        },
        {
          nom: 'Site WordPress',
          description: 'Site WordPress sur le thème du jeu-vidéo',
          background: '/img/projet/themeWordPress.jpg',
          date: "Janvier 2025",
          skills: ['wordpress.png', 'vscode.png', 'canva.png'],
          livrable: " Rendu d'un dossier de production expliquant ce que l'on a réalisé sur le site de manière pédagogique",
          contexte: 'Projet réalisé pour une SAE du semestre 3 en individuel.',
          brief: "Créer un site WordPress, sur le sujet de notre choix, en ajoutant des types de publications par l'utilisation du plugin ACF, et en personnalisant les différents template.",
          rapport: "/files/site_wordpress.pdf"
        },
        {
          nom: 'Expérience 360',
          description: 'Expérience 360 interactive',
          background: '/img/projet/experience360.jpg',
          date: "Avril 2025",
          skills: ["/sphere.png", "/gdoc.png"],
          livrable: " Rendu de l'expérience au format .sph'",
          contexte: 'Projet réalisé pour la SAE "produire du contenu multimédia" du semestre 4 en groupe 5.',
          brief: "Réaliser une expérience 360 interactive sur le logiciel Sphere de Speedernet basée sur un scénario que l'on a rédigé.",
          scenario: "/files/experience360.pdf"
        },
        {
          nom: 'Scénario 360',
          description: 'Court-métrage basé sur un scénario 360',
          background: '/img/projet/scenario360.jpg',
          date: "Janvier 2025",
          skills: ["/premierepro.png", "gdoc.png"],
          livrable: " Rendu de la vidéo au format mp4",
          contexte: "Projet réalisé pour les cours d'audiovisuel du semestre 3 en groupe de 5.",
          brief: "Écrire le script d'une vidéo 360, le tourner et le monter.",
          video: '/video/scenario360.mp4',
          scenario: "/files/scenario360.pdf"
        },
        {
          nom: 'Génome',
          description: "Vidéo d'analyse de génome sur After Effects",
          background: '/img/projet/genome.jpg',
          date: "Avril 2025",
          skills: ["/aftereffects.png", '/illustrator.png'],
          livrable: " Rendu de la vidéo au format mp4",
          contexte: 'Projet réalisé pour les cours de motion design du semestre 4 en individuel.',
          brief: "Reproduire un logiciel d'analyse de génome sur After Effects, tout en créant le logo pour la marque genome analysis",
          video: "/video/genome.mp4"
        },
        {
          nom: 'Carte de voeux',
          description: 'Carte de voeux pour la nouvelle année 2025',
          background: '/img/projet/carteDeVoeux.jpg',
          date: "Janvier 2025",
          skills: ["/aftereffects.png"],
          livrable: " Rendu de la vidéo au format mp4",
          contexte: 'Projet réalisé pour les cours de motion design du semestre 3 en individuel.',
          brief: "Créer une carte de voeux animée pour la nouvelle année 2025 sur After Effects",
          video: '/video/carteDeVoeux.mp4'
        },
        {
          nom: 'PSG - City',
          description: "Affiche d'avant match PSG - Manchester City",
          background: '/img/projet/psg-city.jpg',
          skills: ['photoshop.png'],
          date: "Janvier 2025"
        },
        {
          nom: 'Mbappé',
          description: "Affiche sur Kylian Mbappé",
          background: '/img/projet/kylian2.jpg',
          skills: ['photoshop.png'],
          date: "Août 2024"
        },
        {
          nom: 'Matchday',
          description: "Jour de match du PSG",
          background: '/img/projet/matchday.jpg',
          skills: ['photoshop.png'],
          date: "Août 2024"
        },
        {
          nom: 'Landing Page',
          description: "Landing page du site de l'IUT Sénart-Fontainebleau",
          background: '/img/projet/landingPage.jpg',
          date: "Novembre 2024",
          brief: "Créer une landing page fictive pour le site de l'IUT Sénart-Fontainebleau, en ajoutant un maximum d'animations complexes et esthétiques via du CSS et du Javascript.",
          skills: ['html.svg', 'css.svg', 'vscode.png', 'js.svg'],
          site: "https://alexandre-meux.alwaysdata.net/landingPage/",
        },
        {
          nom: 'Je filme ma formation',
          description: "Vidéo de présentation de la formation MMI",
          background: 'https://eduscol.education.fr/sites/default/files/2022-10/logo-je-filme-ma-formation.jpg',
          date: "Janvier 2025",
          skills: ["/premierepro.png"],
          video_site: "https://parcoursmetiers.tv/video/17772-mmi-lart-de-creer-et-de-transformer",
          livrable: " Rendu de la vidéo au format .mp4",
          contexte: 'Vidéo réalisée dans le cadre de la SAE du semestre 3 en groupe de 4.',
          brief: "Créer une vidéo originale et dynamique pour présenter la formation MMI, notre quotidien, nos projets, nos apprentissages et les débouchés, tout en mobilisant nos compétences.",
        },
        {
          nom: 'Kvaratskhelia',
          description: "Entrainement au light avec Kvaratskhelia",
          background: '/img/projet/kvaratskhelia.png',
          skills: ['photoshop.png'],
          date: "Février 2025"
        },
        {
          nom: 'Kvaratskhelia 2',
          description: "Entrainement au light avec Kvaratskhelia",
          background: '/img/projet/kvaratskhelia2.jpg',
          skills: ['photoshop.png'],
          date: "Février 2025"
        },
        {
          nom: 'Kvaratskhelia 3',
          description: "Affiche sur Khvicha Kvaratskhelia",
          background: '/img/projet/kvaratskhelia3.jpg',
          skills: ['photoshop.png'],
          date: "Février 2025"
        },
        {
          nom: 'Bannière',
          description: "Bannière LinkedIn",
          background: '/img/projet/banniere.jpg',
          skills: ['canva.png'],
          date: "Mai 2025"
        },
        {
          nom: 'Quantum stagiaire',
          description: "Affiche promotionnelle pour un poste de stagiaire chargé(e) de communication chez Quantum",
          background: '/img/projet/stagiaire.jpg',
          skills: ['photoshop.png'],
          date: "Mai 2025"
        },
        {
          nom: 'Golden Boy',
          description: "Affiche sur Désiré Doué",
          background: '/img/projet/doue.jpg',
          skills: ['photoshop.png'],
          date: "Juillet 2025"
        },
        {
          nom: 'Effet Vintage',
          description: "Effet vintage sur une photo de moi",
          background: '/img/projet/oldPicture.jpg',
          skills: ['photoshop.png'],
          date: "Mars 2025"
        },
        {
          nom: 'Entretien étudiant',
          description: "Montage de l'entretien d'un étudiant en MMI sur le thème du numérique",
          background: '/img/projet/entretien.jpg',
          date: "Octobre 2025",
          skills: ["/premierepro.png"],
          video: "/video/entretien.mp4",
          brief: "Réaliser un entretien vidéo d'un étudiant en MMI sur le thème du numérique, en préparant les questions, en filmant l'entretien et en montant la vidéo.",
          livrable: "Projection du short",
        },
        { 
          nom: 'Micro-trottoir',
           description: "Montage du micro-trottoir d'un sénior sur le thème du numérique", 
           background: '/img/projet/microTrottoir.jpg',
           date:"Janvier 2026",
           skills:["/premierepro.png"],
           video:"/video/micro-trottoir.mp4",
          },
          { 
          nom: 'Impasse',
           description: "Court-métrage de l'association Next.Us", 
           background: '/img/projet/impasse.jpg',
           date:"Mars 2026",
           skills:["/premierepro.png","aftereffects.png"],
           video:"/video/impasse.mp4",
           synopsis:"Un homme âgé vit dans un futur entièrement automatisé, jusqu’au jour où il perd la mémoire. En demandant à l’IA de lui montrer le passé, il est projeté dans les années 2000, un monde plus simple et plus humain. Ce voyage entre deux époques met en question notre dépendance à la technologie et ce que nous risquons de perdre en cherchant toujours à aller plus loin.",
           contexte:"Court-métrage réalisé pour l'association Next.Us, dans le cadre d'un projet de fin d'année du semestre 5.",
           brief:"Réaliser un court-métrage pour notre entité, en passant par la rédaction de note d'intention, scénario, découpage technique etc... En utilisant les compétences acquises en audiovisuel et en motion design.",          
          },
           {  
           nom: "Site Next.Us",
           description: "Site de l'association Next.Us", 
           background: '/img/projet/site-nextus.png',
           date:"Mars 2026",
           skills:['wordpress.png','vscode.png'],
           contexte:"Site web réalisé pour l'association Next.Us, dans le cadre d'un projet de fin d'année du semestre 5.",
           site: "http://nextus.mmi-iutsf.org/",
           brief:"Créer un site WordPress pour présenter notre association Next.Us, mettant en avant les différents supports multimédias que nous aurons produits (court-métrage, print, expérience VR).",
          },
      ];
    },
    updateProjectData() {
      const { name } = this.$route.params;
      const allProjects = this.getAllProjects();

      const currentIndex = allProjects.findIndex(
        (proj) => this.normalizeName(proj.nom) === this.normalizeName(name)
      );
      this.project = allProjects[currentIndex] || null;

      this.prevProject = currentIndex > 0 ? allProjects[currentIndex - 1] : null;
      this.nextProject =
        currentIndex < allProjects.length - 1
          ? allProjects[currentIndex + 1]
          : null;
    },
  },
};
</script>

<style scoped>
.backward-link {
  width: 100%;
}

hr {
  width: 90%;
  margin: 6rem auto 0 auto;
}

.not-found {
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.vel-modal {
  z-index: 100000000000000000 !important;
  background: rgba(0, 0, 0, 0.75) !important;
}

.web-link {
  margin: 2vw;
}

.web-link button {
  padding: 1.5rem 2rem !important;
  display: flex;
  align-items: center;
  border-radius: 0;
}

.backward-link span {
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
}

.backward-link div {
  margin-left: 1vw;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

#link-container {
  transition: all 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  padding: 4px 12px 4px 4px;
  border-radius: 100px;
}

#link-container:hover {
  background: var(--gray-hover-1);
}

.backward-arrow {
  filter: invert(1);
  width: 4rem;
  height: 4rem;
  padding: 10px;
  transition: 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.project-counter {
  display: flex;
  justify-content: center;
  gap: 5px;
  text-align: center;
  margin: 3rem;
  font-size: 14px;
  font-weight: 700;
}

.navigation {
  display: flex;
  gap: 2vw;
  justify-content: center;
}

.unfound {
  text-align: center;
  margin: 2rem 0;
}

h1 {
  font-weight: 900;
}

.name-description {
  margin-bottom: 5vw;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.name-description h1 {
  color: var(--yellow-white) !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.name-description p {
  background: var(--gray);
  font-weight: 700;
  font-size: 1.8rem;
}

.project-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5rem 1rem;
}

.grid-section {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: repeat(3, auto);
  justify-items: center;
  align-items: flex-start;
  margin: auto;
  row-gap: 5vw;
  column-gap: 5px;
  padding: 0 2vw
}

.visual {
  grid-row: 1/3;
  grid-column: 2;
  width: 35rem;
  align-self: center !important;
}

.sub-section:nth-of-type(5) {
  grid-row: 3;
  grid-column: 2;
  align-self: baseline;
  width: 70%;
  margin: auto;
}

.section-image {
  filter: invert(0.9);
  width: 4rem;
}

img[class="visual"] {
  box-shadow: var(--box-shadow-1);
  transition: all 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
  border-radius: 9px;
}

img[class="visual"]:hover {
  transform: scale(1.05);
}


@media (max-width:840px) {
  .grid-section {
    display: flex;
    flex-direction: column;
  }

  .visual {
    margin-bottom: 4rem;
  }
}

@media (max-width:545px) {
  .navigation {
    flex-wrap: wrap;
  }

  .navigation button {
    width: 90vw;
  }

  .project-description {
    font-size: 1.5rem !important;
  }
}

.projects-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000000;
}

.modal-content {
  background: var(--hard-blue);
  padding: 2rem;
  border-radius: 12px;
  width: 80%;
  max-width: 800px;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: var(--box-shadow-1);
}

.close-modal {
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 5rem;
  cursor: pointer;
  font-weight: 400;
  padding: 0 !important;
  transition: all 0.45s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.close-modal:hover {
  color: var(--yellow-white);
}

.projects-list {
  list-style: none;
  padding: 0;
}

.project-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid var(--gray-hover-1);
}

.project-item:hover {
  background: var(--gray-hover);
}

.project-item:hover .project-thumbnail-number {
  font-family: var(--font-number-title);
}

.project-thumbnail-number {
  font-family: var(--font-number-title-outlined);
  object-fit: contain;
  margin-right: 2rem;
  font-size: 8rem;
  color: var(--gray);
}

.projects-modal .project-name {
  font-weight: bold;
  font-size: 16px;
}

.projects-modal .project-description {
  font-weight: 400;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75)
}
</style>